// src/Footer.js
import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="pfooter">© 2024 Motivational Quote Generator</p>
      <p className="pfooter">
        Created by <a href="https://x.com/davvzin" className="footer-link">Davi</a>
      </p>
    </footer>
  );
};

export default Footer;
